$mol_icon_navigation $mol_icon path \M12,2L4.5,20.29L5.21,21L12,18L18.79,21L19.5,20.29L12,2Z
